import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IResultPackageSummaryPayload } from '../../../types';

/**
 * This is to track the device categories from the backend.
 */
const PACKAGE_SUMMARY_QUERY_KEY = 'package-summary-query-key';

/**
 * This hook fetches list of package details from mock APi.
 * TODO: Replace this with actual API call and add proper types.
 */
export const usePackageSummaryQuery = (
  payload: IResultPackageSummaryPayload
) => {
  const { appraisalCode, inventoryId } = payload;

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [PACKAGE_SUMMARY_QUERY_KEY, appraisalCode, inventoryId],
    networkMode: 'always',
    retry: false,
    queryFn: () => INV_MGMT_SERVICE_API.getPackageSummary(payload),
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
